import React, { useEffect, useState } from "react";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config } from "../../../../../config";
import { useHistory } from "react-router-dom";

function Disclaimer(props) {
  const [sports, setSports] = useState([]);
	const history = useHistory();
  const getSports = () => {
    axiosApi.get(`${config.apiUrl}/sport-notification`)
    .then((res) => {
      setSports(res?.data?.data);
    })
  }

  useEffect(() => {
    getSports();
  }, [])
	return (
		<div className="content-wrapper sendEmail-wrapper contactUs-wrapper disclaimer-wrapper">
			<div className="header">
				<div className="header-blk">
					<h2>Sports Notification</h2>
					<p>
						You can edit sport notifications.
					</p>
				</div>
			</div>
			{sports.length ? sports.map((x, i) => (
				<div key={i} className="classsifieds">
					<div className="classifieds-left">
						<h5> {x?.title}</h5>
						<p className="disclaimer" dangerouslySetInnerHTML={{
							__html: x?.notification,
						}}></p>
					</div>
					<div className="classifieds-right">
						<span style={{
							color: '00788b',
							textDecoration: 'underline'
						}} onClick={() => (history.push(`/admin/settings/sport-notification/${x?.id}`))} >Edit</span>
					</div>
				</div>
			)) : ''}
		</div>
	)

}
export default Disclaimer;